import { Html } from '@react-three/drei';
import { useSelectionStore } from '@/state/selection';

export function Labels() {
  const labels = useSelectionStore((s) => s.labels);
  const bounds = useSelectionStore((s) => s.bounds);
  if (!labels.length || !bounds) return null;
  return (
    <group>
      {labels.map((l) => {
        const b = bounds[l.id];
        if (!b) return null;
        return (
          <Html
            key={l.id}
            position={[(b[0] + b[3]) / 2, b[4] + 0.3, (b[2] + b[5]) / 2]}
            center
            zIndexRange={[1, 0]}
            style={{ pointerEvents: 'none' }}
          >
            <span className="scene-label">{l.text}</span>
          </Html>
        );
      })}
    </group>
  );
}
